import { useRef as o } from "react";
var c = function c() {},
  u = function u(_ref) {
    var e = _ref.computeCustomOffset,
      t = _ref.onChangeVisible;
    var n = o(null),
      s = o(null),
      i = o(e),
      f = o(t || c);
    return {
      childrenRef: n,
      visibilityRef: s,
      computeCustomOffsetRef: i,
      onChangeVisibleRef: f
    };
  };
export { u as useTooltipRefs };